import * as styles from "./StandardSignPostCard.module.scss";

import React, { useCallback, useEffect, useState } from "react";

import cx from "classnames";
import { navigate } from "gatsby";
import CurvedBorder from "../../../components/borders/CurvedBorder";
import CurvedBorderVertical from "../../../components/borders/CurvedBorderVertical";
import FuzzyBorder from "../../../components/borders/FuzzyBorder";
import FuzzyBorderVertical from "../../../components/borders/FuzzyBorderVertical";
import { Colours } from "../../../utils/colours";
import { formatDateNoYear } from "../../../utils/dates";
import { pushToDataLayer } from "../../../utils/google";
import Button from "../../common/Button";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export const StandardSignPostCard: React.FC<DogsTrust.SignPostCardProps> = ({
	imgSrc,
	title,
	body,
	buttonLabel,
	buttonUrl,
	externalUrl,
	isSuccessStory,
	date,
	isRTE,
	registerSignpostCard,
	unregisterSignpostCard,
	buttonVariant = "tertiary",
	forceSquare = false,
	promoLabel = null,
}) => {
	const Border = isSuccessStory ? FuzzyBorder : CurvedBorder;
	const VerticalBorder = isSuccessStory
		? FuzzyBorderVertical
		: CurvedBorderVertical;

	const [hasRegistered, setHasRegistered] = useState<boolean>(false);

	useEffect(() => {
		if (!hasRegistered) {
			registerSignpostCard?.(title, body?.length || 0);
			setHasRegistered(true);
		}
	}, [hasRegistered, registerSignpostCard, body, title]);

	useEffect(
		() => () => unregisterSignpostCard?.(title),
		[unregisterSignpostCard, title],
	);

	return (
		<article
			className={cx({
				[styles.cardcontainer]: !forceSquare,
				[styles.cardcontainersquare]: forceSquare,
			})}
		>
			<div className={styles.cardimagecontainer}>
				<ProcessedImage
					className={styles.cardimage}
					src={imgSrc}
					dimensions="400x300"
					alt={title}
					onClick={() => {
						pushToDataLayer({
							event: "button_navigation",
							button_clicked: buttonLabel,
						});
						navigate(buttonUrl);
					}}
					loading={"lazy"}
				/>
				{promoLabel}
				<div className={styles.cardbordercontainer}>
					<Border
						className={styles.cardborder}
						rotation={0}
						fill={Colours.WHITE}
					/>
					<VerticalBorder
						className={styles.verticalcardborder}
						rotation={180}
						fill={Colours.WHITE}
					/>
				</div>
			</div>

			<div className={styles.carddetails}>
				<div>
					<h2 data-variation="hideFromJumpLinks" className={styles.cardtitle}>
						{title}
					</h2>
					<div className={styles.cardtext}>
						{isRTE ? (
							<div
								className={styles.cardtext}
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: body,
								}}
							/>
						) : (
							<p>{body}</p>
						)}
					</div>
				</div>
				<div>
					{!!date && (
						<div className={styles.date}>
							<span>{`${formatDateNoYear(new Date(date))}`}</span>
						</div>
					)}
					<Button
						className={styles.cardcta}
						variant={buttonVariant}
						size="small"
						url={buttonUrl}
						externalUrl={externalUrl}
					>
						{buttonLabel}
					</Button>
				</div>
			</div>
		</article>
	);
};

export default StandardSignPostCard;
